export const GET_KNOWLEDGE_BASE = "getKnowledgeBase";
